import { APIMethod, fetchData } from "@client";

export async function removeRateCardTeamMemberQuery(roleId) {
  return await fetchData(`/company/rate-card/roles/${roleId}`, APIMethod.DELETE);
}
